import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('order_ratings.rating_detail.pager')

type Props = {
  position: number
  total: number
  hasPrev: boolean
  hasNext: boolean
  onPrev: () => void
  onNext: () => void
}

// The header's "‹ Case N of M unresolved ›" pager (AI-1023). Presentational —
// RatingDetail owns the neighbors query and routes prev/next to the adjacent
// rating. Rendered only when the rating is in the unresolved set. Chevrons are
// uikit minimal Buttons (a11y defaults + disabled states) with an aria-label,
// mirroring the RestrictedCustomers/Pagination pattern.
const RatingPager = ({
  position,
  total,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
}: Props) => {
  const [css] = useStyletron()

  const chevron = (direction: 'left' | 'right') =>
    css({
      color: palette.grey70,
      fontSize: '16px',
    }) + ` fa fa-chevron-${direction}`

  return (
    <div className={`d-flex align-items-center ${css({ gap: '8px' })}`}>
      <Button
        kind="minimal"
        onClick={onPrev}
        disabled={!hasPrev}
        aria-label={t('prev')}
      >
        <i className={chevron('left')} aria-hidden="true" />
      </Button>
      <Text.BodyText4 tag="span" color="grey90">
        {t('label', { position, total })}
      </Text.BodyText4>
      <Button
        kind="minimal"
        onClick={onNext}
        disabled={!hasNext}
        aria-label={t('next')}
      >
        <i className={chevron('right')} aria-hidden="true" />
      </Button>
    </div>
  )
}

export default RatingPager
